export const convertBaseURL = (fileUrl) => {
    if(typeof fileUrl == 'undefined') return fileUrl
	fileUrl = fileUrl.replace("https://", "").replace("http://","");
    let idx = fileUrl.indexOf("/");
    let rightPart = fileUrl.substr(idx, fileUrl.length - idx);
    return window.location.origin + rightPart;
}

// FileManager2's /upload/<instance>/<addPath> route treats every "/" in addPath as a
// new path segment (max 4 after /upload/), so a raw item no like "BD-SL/KS/000007"
// splits into extra segments and 404s. Replace characters that are illegal in a file
// name or significant in a URL path with "_" so the upload always lands in one segment.
export const sanitizeForUploadPath = (value) => {
    if (value === null || typeof value === 'undefined') return value
    return String(value).replace(/[\\/:*?"<>|#%]/g, '_')
}
